import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DeleteButton,
  RichTextField,
  Edit,
  AutocompleteArrayInput,
  NumberField,
  ReferenceArrayInput,
  ReferenceArrayField,
  ReferenceArrayFieldView,
  NumberInput,
  SingleFieldList,
  ChipField,
  BooleanInput,
  BooleanField,
} from "react-admin";

export const PlanList = (props) => (
  <List
    {...props}
  >
    <Datagrid>
      <TextField source="title" label="Titre" />
      <ReferenceArrayField source="categories" reference="categories" label="Categorie">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <NumberField source="price" label="Prix" />
      <TextField source="description" label="Description" />
      <BooleanField source="supportVisio" label="Visio conférence incl." />
      <TextField source="currency" label="Monnaie" />
      <TextField source="createdby" label="Créer par" />
      <DeleteButton label="" redirect={false} />
      <EditButton label="" />
      <ShowButton />

    </Datagrid>
  </List>
);

// const ConditionalEmailField = ({}) =>
//   record && record.hasEmail ? (
//     <EmailField source="email" record={record} {...rest} />
//   ) : null;
export const PlanShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="title" label="Titre" />
      <TextField source="price" label="Price" />
      <TextField source="currency" label="Monnaie" />
      <RichTextField source="description" label="Description" />
      <BooleanField source="supportVisio" label="Visio conférence incl." />
      <ReferenceArrayField source="categories" reference="categories" label="Categorie">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <TextField source="createdby" label="Créer par" />
    </SimpleShowLayout>
  </Show>
);

export const PlanCreate = (props) => (

  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" label="titre" />
      <TextInput source="currency" label="Currency" />
      <NumberInput source="price" label="Prix" />
      <BooleanInput source="supportVisio" label="Visio conférence incl." />
      <TextInput source="description" label="Description" />
      <ReferenceArrayInput source="categories" reference="categories" label="Categorie" >
        <AutocompleteArrayInput optionText="name" label="Categorie" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Create>
);

export const PlanEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="title" label="titre" />
      <TextInput source="currency" label="Currency" />
      <NumberInput source="price" label="Prix" />
      <BooleanInput source="supportVisio" label="Visio conférence incl." />
      <TextInput source="description" label="Description" />
      <ReferenceArrayInput source="categories" reference="categories" label="Categorie" >
        <AutocompleteArrayInput optionText="name" label="Categorie" />
      </ReferenceArrayInput>
    </SimpleForm>
  </Edit>
);
